module.exports = __webpack_public_path__ + "static/media/meal.29a12a05.jpg";